import { getDWPInfo } from "../network/Network";
import { CORE_AMZL } from "../util/Constants";

export const DWPMetadataReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_DWP_INFO": {
      const { dispatcher, baseUrl, capability, stationConfig } = action.data;
      if (CORE_AMZL === capability && stationConfig.planFinalizationEnabled) {
        // Query DWP Metadata if planFinalization is enabled for the site
        getDWPInfo(dispatcher, baseUrl, stationConfig);
      }
      return state;
    }
    case "RECEIVE_DWP_INFO": {
      return { ...state, ...action.data };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/reducers/DWPMetadataReducer.js